import React from 'react'
import {ServicesContextData, ServicesContext} from './ServicesProvider'

const useServicesContext = (): ServicesContextData => React.useContext(ServicesContext)

export default useServicesContext
